export default {
    header: {
        company: "Cuprolli Manufacturing srl",
        vatId: "RO 35671874",
        regCom: "J2016000468359",
        address1: "Strada Caprioarei 11",
        address2: "307200 Ghiroda, Timis megye",
        address3: "ROMÁNIA",
        email: "export@i-struct.eu",
        phone: "+40 748 179 927",
        website: "https://i-struct.hu",
        bankName: "Banca Transilvania",
        ibanNo: "RO89 BTRL EURC RT03 3757 8301",
        vatRate: "19%",
        validDays: "5",
    },
    dateFormat: "yyyy.MM.dd",
    labels: {
        proforma: "PROFORMA SZÁMLA",
        proformaValidity: "A proforma számla érvényessége",
        days: "nap",
        from: "dátumtól",
        piece: "db.",
        vatId: "EU adószámr",
        regCom: "Cégjegyzékszám",
        bank: "Bank",
        iban: "IBAN",
        client: "Ügyfél",
        mrMrs: "Úr/Hölgy",
        email: "E-Mail",
        phone: "Tel",
        vatRate: "ÁFA-kulcs",
        vatFree: "ÁFA-mentes",
        downPayment: "előleg",
        accordingToOfferNo: "az ajánlat száma szerint:",
        no: "Sz",
        productName: "Termék megnevezése",
        qty: "Mennyiség",
        onePrice: "Egységár",
        netAmount: "Nettó összeg",
        subtotal: "Részösszeg",
        woVat: "ÁFA nélkül",
        vat: "ÁFA",
        total: "Végösszeg",
        note1: "* Fordított adózás",
        note2: "Az adófizetési kötelezettség áthelyezése"
    },
    messages: {
        endPageMessage: "Folytatás a következő oldalon"
    }
}